import { Component, OnInit, Input, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { AutomateJob, AutomateTask } from '../../global/models';

import { ClassifierService } from '../../services/classifier.service';


@Component({
  selector: 'task-popover',
  templateUrl: './task-popover.component.html',
  styleUrls: ['./task-popover.component.scss']
})
export class TaskPopoverComponent implements OnInit {

  @Input() task: AutomateTask;
  @Input() job: AutomateJob;

  pillFirst: string = '';
  pillSecond: string = '';
  body: string = '';

  constructor(private classifierService: ClassifierService,
              private domSanitizer: DomSanitizer) { }

  ngOnInit() {
    if (this.task.type == 'track') {
      this.formatTrack();
    }
    else if (this.task.type == 'route') {
      this.formatRoute();
    }
    else if (this.task.type == 'create') {
      this.formatCreate();
    }
    else if (this.task.type == 'enrich') {
      this.formatEnrich();
    }
    else if (this.task.type == 'cdo') {
      this.formatCDO();
    }
    else if (this.task.type == 'respond') {
      this.classifierService.getClassifier(this.task.settings.classifier_id, true).subscribe(
        (result: any) => {
          this.formatBotRespond(result);
        },
        e => {

        }
      );
    }
    else if (this.task.type == 'respondtrack') {
      this.classifierService.getClassifier(this.task.settings.classifier_id, true).subscribe(
        (result: any) => {
          this.formatBotTrack(result);
        },
        e => {

        }
      );
    }
  }

  private formatRoute() {
    this.pillFirst = 'Route';
    this.pillSecond = this.task.settings.type;
    let temp: string = '';

    if (this.task.settings.type == 'static') {
      if (this.task.settings.static.length > 0) {
       temp = `Route to <strong>${this.task.settings.static.map(s => { return s.email_address }).join(', ')}</strong>`;
      }
      else {
        temp = `<span class="tone-low">Route is invalid: need at least one email address configured.</span>`;
      }
    }
    else if (this.task.settings.type == 'dynamic') {
      if (this.task.settings.dynamic.length > 0) {
        temp = `Route to [alias]<strong>@${this.task.settings.dynamic}</strong>`;
        if (this.task.settings.static.length > 0) {
          temp += `<hr/>In addition, route to <strong>${this.task.settings.static.map(s => { return s.email_address }).join(', ')}</strong>`;
        }
      }
      else {
        temp = `<span class="tone-low">Route is invalid: need a domain specified for dynamic routing.</span>`;
      }
    }
    else if (this.task.settings.type=='leadowner') {
      temp = `Route to Lead Owner in ${this.task.settings.lead_owner.partner} using field <strong>${this.task.settings.lead_owner.field.display}</strong>`;
      temp += `<hr/>In case of failure, fall back to <strong>${this.task.settings.lead_owner.fallback.join(', ')}</strong>`;
      if (this.task.settings.static.length > 0) {
        temp += `<hr/>In addition, route to <strong>${this.task.settings.static.map(s => { return s.email_address }).join(', ')}</strong>`;
      }
    }
    else {
      this.pillSecond = 'Not Set';
      temp = `Route configuration is incomplete`;
    }

    this.body = this.domSanitizer.sanitize(SecurityContext.HTML, temp);
  }

  private formatTrack() {
    if (this.job.type == 'updatecontacts') {
      this.pillFirst = 'Update';
    }
    else {
      this.pillFirst = 'Track';
    }

    let temp: string = '';
    if (this.task.settings.partner.length > 0) {
      this.pillSecond = this.task.settings.partner;
      if (this.task.settings.list.id) {
        temp = `Add to list <strong>${this.task.settings.list.name}</strong>`;
      }

      if (this.task.settings.static_fields.length + this.task.settings.siftrock_fields.length > 0) {
        let fields = this.task.settings.static_fields.map(sf => { return sf.display});
        fields = fields.concat(this.task.settings.siftrock_fields.map(srf => { return srf.display }));
        if (temp.length > 0) {
          temp += `<hr/>`;
        }
        temp += `Update fields: <strong>${fields.join(', ')}</strong>`;
      }
    }
    else {
      this.pillSecond = 'Not set';
      temp = `${this.pillFirst} is not configured for this skill.`;
    }

    this.body = this.domSanitizer.sanitize(SecurityContext.HTML, temp);
  }

  private formatCreate() {
    this.pillFirst = 'Create';
    let temp: string = '';
    if (this.task.settings.partner.length > 0) {
      this.pillSecond = this.task.settings.partner;
      if (this.task.settings.list.id) {
        temp = `Add to list <strong>${this.task.settings.list.name}</strong>`;
      }

      let static_fields = this.task.settings.static_fields || [];
      let siftrock_fields  =  this.task.settings.siftrock_fields || [];
      let sender_fields = this.task.settings.sender_fields || [];

      if (static_fields.length + siftrock_fields.length + sender_fields.length> 0) {
        let fields = static_fields.map(sf => { return sf.display});
        fields = fields.concat(siftrock_fields.map(srf => { return srf.display }));
        fields = fields.concat(sender_fields.map(sdf => { return sdf.display }));
        if (temp.length > 0) {
          temp += `<hr/>`;
        }
        temp += `Update fields: <strong>${fields.join(', ')}</strong>`;
      }
    }
    else {
      this.pillSecond = 'Not set';
      temp = `Create is not configured.`;
    }
    this.body = this.domSanitizer.sanitize(SecurityContext.HTML, temp);
  }

  private formatEnrich() {
    this.pillFirst = 'Enrich';
    this.pillSecond = this.task.settings.partner;
    let temp: string = `Phone Number <strong>${this.task.settings.phone.enabled ? 'Enabled': 'Disabled'}</strong><hr/>Title <strong>${this.task.settings.phone.enabled ? 'Enabled': 'Disabled'}</strong>`;
    this.body = this.domSanitizer.sanitize(SecurityContext.HTML, temp);
  }

  private formatCDO() {
    this.pillFirst = 'CO Sync';
    this.pillSecond = this.task.settings.partner;
    this.task.type = 'Custom Object'
    let temp: string = '';

    if (this.task.settings.list.id) {
      temp = `Add to list <strong>${this.task.settings.list.name}</strong>`;
    }

    if (this.task.settings.static_fields.length + this.task.settings.siftrock_fields.length + this.task.settings.recipient_fields.length> 0) {
      let fields = this.task.settings.static_fields.map(sf => { return sf.description});
      fields = fields.concat(this.task.settings.siftrock_fields.map(srf => { return srf.description }));
      fields = fields.concat(this.task.settings.recipient_fields.map(sdf => { return sdf.description }));
      if (temp.length > 0) {
        temp += `<hr/>`;
      }
      temp += `Update fields: <strong>${fields.join(', ')}</strong>`;
    }
    this.body = this.domSanitizer.sanitize(SecurityContext.HTML, temp);
  }

  private formatBotRespond(classifier: any) {
    this.pillFirst = 'Bot';
    this.pillSecond = 'Respond';
    let temp: string = '';

    if (classifier) {
      this.task.settings.categories.forEach(taskCat => {
        let clCat = classifier.category.find(cat => {
          return cat.id == taskCat.categoryId;
        });
        if (taskCat.action == 'send') {
          temp += `If <strong>${clCat.name}</strong>, automatically send a reply<br/>`
        }
        else if (taskCat.action == 'draft') {
          if (temp.length > 0) {
            temp += `<hr/>`;
          }
          temp += `If <strong>${clCat.name}</strong>, create a draft reply`
        }
      });
    }

    this.body = this.domSanitizer.sanitize(SecurityContext.HTML, temp);
  }

  private formatBotTrack(classifier: any) {
    this.pillFirst = 'Track';
    this.pillSecond = 'Respond';
    let temp: string = '';

    if (this.task.settings.partner.length > 0) {
      this.pillSecond = this.task.settings.partner;

      if (classifier) {
        this.task.settings.categories.forEach(taskCat => {
          let clCat = classifier.category.find(cat => {
            return cat.id == taskCat.categoryId;
          });

          if (temp.length > 0) {
            temp += `<hr/>`;
          }
          temp += `If <strong>${clCat.name}</strong>, track`;
        });
      }
    }
    else {
      this.pillSecond = 'Not set';
      temp = `${this.pillFirst} is not configured for this skill.`;
    }

    this.body = this.domSanitizer.sanitize(SecurityContext.HTML, temp);
  }
}



// WEBPACK FOOTER //
// ./client/app/automate/task-popover/task-popover.component.ts